import "../scss/app.scss"; // Importing SCSS file

 
function GP_JOHNSON_ARCHITECTS() {
  let portfolios = [...home_images.home_images];
  // randomly select a portfolio
  let random_portfolio = portfolios[Math.floor(Math.random() * portfolios.length)];
 
  

  let background_img = document
    .getElementById("slider-background-image")
    .querySelector("img");

  background_img.setAttribute("src",random_portfolio.thumbnail);

  let headline = document.getElementById("headline");

  let headline_h1_a = headline.querySelector("h1 a");
  let span_a = document.querySelector("span a");
  headline_h1_a.href =random_portfolio.portfolio_link;
  span_a.href =random_portfolio.portfolio_link;
  headline_h1_a.innerHTML =random_portfolio.title;
  span_a.innerHTML =random_portfolio.subheadline;
}
 if (window.location.href.replace(site_url, "") == '/') {
   
  GP_JOHNSON_ARCHITECTS()
 }
 
 
  
// if page_url contains /portfolio/  or /portfolio
if (page_url.includes("/portfolio")) {
  const searchToggle = document.getElementById("search-toggle");
  searchToggle.onclick = function (e) {
    e.preventDefault();
    const searchInput = searchToggle.parentElement.querySelector("input");
    searchInput.classList.toggle("active");
    searchInput.focus();
    searchToggle.style.display = "none";
  };
}
 

 
 


